const organization = {
    require_membership: 'Kullanıcının devam etmek için organizasyonun bir üyesi olması gerekir.',
    role_names_not_found: '检测到无效的角色名称：{{names,list(type:conjunction)}}。请先创建这些角色，然后再继续。',
};
export default Object.freeze(organization);
